import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationTagActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Tag/TagBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingConfigurationTag"
				RenderedComponent={this.RenderedComponent}
				context="AccountingConfigurationTag"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationTagActivity)
